import React from 'react';

const LinkedinIcon = () => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M17.9954 18.0002V17.9994H17.9999V11.3979C17.9999 8.16841 17.3047 5.68066 13.5292 5.68066C11.7142 5.68066 10.4962 6.67666 9.99895 7.62091H9.94645V5.98216H6.3667V17.9994H10.0942V12.0489C10.0942 10.4822 10.3912 8.96716 12.3314 8.96716C14.2432 8.96716 14.2717 10.7552 14.2717 12.1494V18.0002H17.9954Z' fill='#0077B5' />
    <path d='M0.296875 5.9834H4.02888V18.0006H0.296875V5.9834Z' fill='#0077B5' />
    <path d='M2.1615 0C0.96825 0 0 0.96825 0 2.1615C0 3.35475 0.96825 4.34325 2.1615 4.34325C3.35475 4.34325 4.323 3.35475 4.323 2.1615C4.32225 0.96825 3.354 0 2.1615 0V0Z' fill='#0077B5' />
  </svg>
);

export default LinkedinIcon;
